//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useEffect, useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// custom pages
import useDebounce from 'helpers/useDebounce';
import lotaltyApi from 'apis/loyalty/loyalty';
import Context from 'context/context';
import Table from 'components/Table/Table';
import { loyaltyStyles } from './styles';
import Loader from 'components/Loader/Loader';
import access from 'config/access';

// material-ui
import { withStyles } from '@material-ui/styles';
import Grid from '@material-ui/core/Grid';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { green } from '@material-ui/core/colors';
import Radio from '@material-ui/core/Radio';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Card from '@material-ui/core/Card';

// material-ui icons
import MenuIcon from '@material-ui/icons/Menu';
import { blockInvalidChar } from 'helpers/blockInvalidChar';

//Helpers
import { dateFormat } from "helpers/dataFormat"

const GreenRadio = withStyles({
  root: {
    color: green[400],
    '&$checked': {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Radio color='default' {...props} />);

const GlobalCss = withStyles({
  '@global': {
    '.MuiOutlinedInput-root': {
      borderRadius: 20,
      marginTop: 0,
    },
    '.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: 0,
    },
    '.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-child':
    {
      paddingLeft: 20,
    },
  },
})(() => null);

export default function Loyalty(props) {
  const { t, i18n } = useTranslation();
  const { state, dispatch } = useContext(Context);
  const { search, getLoyaltyUser, selectMemberAccount } = lotaltyApi();

  const classes = loyaltyStyles();
  const history = useHistory();
  const location = useLocation();

  const [shiptoSearch, setShiptoSearch] = useState('');
  const [loyaltySearch, setLoyaltySearch] = useState('');
  const [billtoSearch, setBilltoSearch] = useState('');
  const [searchType, setSearchType] = useState('');
  const shiptoSearchBounceValues = useDebounce(shiptoSearch);
  const loyaltySearchBounceValues = useDebounce(loyaltySearch);
  const billtoSearchBounceValues = useDebounce(billtoSearch);

  const [data, setData] = useState([]);
  const [shiptoLoading, setShiptoLoading] = useState(false);
  const [loyaltyLoading, setLoyaltyLoading] = useState(false);
  const [billtoLoading, setBilltoLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");

  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [accountType, setAccountType] = useState('');

  const [deactiveAccount, setdeactiveAccount] = useState("");

  const [loyaltyAccount, setLoyaltyAccount] = useState({});

  const [open, setOpen] = React.useState(false);

  // For bread-crumbs
  useEffect(() => {
    dispatch({ type: 'SET_PATHNAME', payload: ['HOME', "CHANGE ACCOUNT"] });
  }, []);

  // handling pagination func
  const handlePagination = (value) => {
    setOffset(value);
  };

  useEffect(() => {
    if (
      state.userInfo &&
      Object.keys(state.userInfo).length > 0 &&
      access['loyalty'][state.userInfo.role]
    ) {
      return;
    } else {
      // return history.push('/dashboard/mydashboard');
    }
  }, [state.userInfo]);

  useEffect(() => {
    if (searchType.length > 0) {
      handleSelectUser();
    }
  }, [selectedValue]);

  // handling search api call
  useEffect(() => {
    if (shiptoSearchBounceValues && shiptoSearchBounceValues.length > 0) {
      handleSearch();
    }
  }, [shiptoSearchBounceValues]);

  // handling search api call
  useEffect(() => {
    if (loyaltySearchBounceValues && loyaltySearchBounceValues.length > 0) {
      handleSearch();
    }
  }, [loyaltySearchBounceValues]);

  // handling search api call
  useEffect(() => {
    if (billtoSearchBounceValues && billtoSearchBounceValues.length > 0) {
      handleSearch();
    }
  }, [billtoSearchBounceValues]);

  useEffect(() => {
    if (shiptoSearch.length > 0) {
      setShiptoLoading(true);
    } else {
      setData([]);
      setShiptoLoading(false);
    }
    if (loyaltySearch.length > 0) {
      setLoyaltyLoading(true);
    } else {
      setData([]);
      setLoyaltyLoading(false);
    }
    if (billtoSearch.length > 0) {
      setBilltoLoading(true);
    } else {
      setData([]);
      setBilltoLoading(false);
    }
  }, [shiptoSearch, loyaltySearch, billtoSearch]);

  // search api func
  const handleSearch = async () => {
    try {
      let values;
      if (searchType === 'loyalty_id') {
        values = {
          searchValue: loyaltySearch,
          searchType: searchType,
        };
      }
      if (searchType === 'customer_account_number') {
        values = {
          searchValue: shiptoSearch,
          searchType: searchType,
        };
      }
      if (searchType === 'customer_billto_account_number') {
        values = {
          searchValue: billtoSearch,
          searchType: searchType,
        };
      }
      let res = await search(values);
      if (res) {
        setData(res.data);
      }
      setShiptoLoading(false);
      setLoyaltyLoading(false);
      setBilltoLoading(false);
    } catch (e) {
      console.log('errors');
    }
  };

  // loyalty user api call
  // const handleGetShiptoUsers = async () => {
  //   if (!selectedValue) {
  //     return;
  //   }
  //   try {
  //     let values;
  //     if (searchType === 'loyalty_id') {
  //       values = {
  //         loyalty_id: selectedValue,
  //         searchType: searchType,
  //         offset: (offset - 1) * 10,
  //         limit: 10,
  //       };
  //     }
  //     if (searchType === 'customer_account_number') {
  //       values = {
  //         customer_account_number: selectedValue,
  //         searchType: searchType,
  //         offset: (offset - 1) * 10,
  //         limit: 10,
  //       };
  //     }
  //     if (searchType === 'customer_billto_account_number') {
  //       values = {
  //         customer_billto_account_number: selectedValue,
  //         searchType: searchType,
  //         offset: (offset - 1) * 10,
  //         limit: 10,
  //       };
  //     }
  //     dispatch({ type: 'SET_LOADING', payload: true });
  //     let res = await getLoyaltyUser(values);
  //     // console.log(res,"this is the response")
  //     if (res && res?.accountType) {
  //       if (res && res.accountType === 'user-accounts') {
  //         // setUsers(res.data);
  //         // setCount(res.count);
  //         handleSelectUser(res?.data[0])
  //       }
  //       if (res && res.accountType === 'loyalty-account') {
  //         // setLoyaltyAccount(res.data);
  //         handleSelectUser(res.data)
  //       }
  //       if (res && res.accountType === "deactive user-account") {
  //         // console.log(res.message.message, "res.message.message")
  //         setdeactiveAccount(res.message.message);
  //       }
  //       setAccountType(res.accountType);
  //     }

  //     dispatch({ type: 'SET_LOADING', payload: false });
  //     return;
  //   } catch (e) {
  //     console.log({ e });
  //   }
  // };

  // selecting user func
  const handleSelectUser = async (user) => {
    try {
      let values = {}
      values = {
        searchType: searchType,
        selectedValue: selectedValue
      }
      let res = await selectMemberAccount(values);
      if (res && res.accountType == "deactive user-account" || (res && res.accountType == "deactive user-account-shipto")) {        
        setdeactiveAccount(res.message.message);
        setAccountType(res.accountType);
      } else {
        dispatch({ type: "SET_ALA", payload: res?.loyaltyAccount });
        dispatch({ type: "SET_ACA", payload: res?.customerAccount });
        console.log("loyaltyAccount object:", res.loyaltyAccount);

        const dormantFlag = res.loyaltyAccount?.["Loyalty_Account.dormant_account_flag"];
        const dormantProcessed = res.loyaltyAccount?.["Loyalty_Account.dormant_processed"];
        // console.log("Dormant Flag:", dormantFlag);
        // console.log("Dormant Processed:", dormantProcessed);
        
  
        const shiptoCount = res?.count;
  
   
        //console.log("Shipto Count:", shiptoCount);
  
        if (dormantFlag && dormantProcessed) {
          history.push('/dashboard/dormant-view');
        } else if (shiptoCount > 1) {
          history.push('/dashboard/locations');
        } else {
          history.push('/dashboard/mydashboard');
        }
      }
    } catch (e) {
      console.log({ e });
    }
  };
  
  
  return (
    <React.Fragment>
      <GlobalCss />
      <Grid container spacing={0}>
        <Grid xs={12} item>
          <Grid container spacing={0}>
            <Grid item xs={12} className={classes.headingText}>
              {window.innerWidth < 600 && (
                <span>
                  <IconButton
                    style={{ padding: 0 }}
                    onClick={() => {
                      dispatch({ type: 'SET_SIDEBAR', payload: true });
                    }}
                  >
                    <MenuIcon style={{ color: '#fff' }} />
                  </IconButton>
                </span>
              )}{' '}
              {t('Choose Customer Account')}
            </Grid>
            <Grid container spacing={0}>
              <Grid item lg={12}>
                <div className={classes.headingText2}>
                  {t(
                    'Please type the customer ship to account number to view their loyalty information'
                  )}
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
                lg={4}
                className={classes.headingText2Grid}
              >
                <Autocomplete
                  id='shipto-search'
                  // key={loyaltySearch}
                  options={data}
                  getOptionLabel={(o) => o.customer_account_number}
                  filterOptions={(options, state) => options}
                  inputValue={shiptoSearch}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant='outlined'
                      type='number'
                      onKeyDown={blockInvalidChar}
                      value={shiptoSearch}
                      placeholder={t('Search by Shipto')}
                                    onWheel={(e) => e.target.blur()}
                      onChange={(e) => {
                        setShiptoSearch(e.target.value);
                      }}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {shiptoLoading ? (
                              <CircularProgress color='inherit' size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                      onClick={() => {
                        setSearchType('customer_account_number');
                        setLoyaltySearch('');
                        setBilltoSearch('');
                      }}
                    />
                  )}
                  onChange={(value, a, reason) => {
                    if (reason === 'clear') {
                      setShiptoSearch('');
                      return;
                    }
                    if (a) {
                      setSelectedValue(a.customer_account_number);
                      setOffset(1);
                    }
                  }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
                lg={4}
                className={classes.headingText2Grid}
              >
                <Autocomplete
                  id='loyalty-search'
                  // key={shiptoSearch}
                  options={data}
                  getOptionLabel={(o) => o.loyalty_id}
                  filterOptions={(options, state) => options}
                  inputValue={loyaltySearch}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant='outlined'
                      type='number'
                         onWheel={(e) => e.target.blur()}
                      onKeyDown={blockInvalidChar}
                      value={loyaltySearch}
                      placeholder={t('Search by Loyalty ID')}
                      onChange={(e) => {
                        setLoyaltySearch(e.target.value);
                      }}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {loyaltyLoading ? (
                              <CircularProgress color='inherit' size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                      onClick={() => {
                        setSearchType('loyalty_id');
                        setShiptoSearch('');
                        setBilltoSearch('');
                        // document.getElementById("shipto-search").value = "";
                      }}
                    />
                  )}
                  onChange={(value, a, reason) => {
                    if (reason === 'clear') {
                      setLoyaltySearch('');
                      return;
                    }
                    if (a) {
                      setSelectedValue(a.loyalty_id);
                      setOffset(1);
                    }
                  }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
                lg={4}
                className={classes.headingText2Grid}
              >
                <Autocomplete
                  id='billto-search'
                  // key={shiptoSearch}
                  options={data}
                  getOptionLabel={(o) => o.customer_billto_account_number}
                  filterOptions={(options, state) => options}
                  inputValue={billtoSearch}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant='outlined'
                      type='number'
                         onWheel={(e) => e.target.blur()}                         
                      onKeyDown={blockInvalidChar}
                      value={billtoSearch}
                      placeholder={t('Search by Billto ID')}
                      onChange={(e) => {
                        setBilltoSearch(e.target.value);
                      }}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {billtoLoading ? (
                              <CircularProgress color='inherit' size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                      onClick={() => {
                        setSearchType('customer_billto_account_number');
                        setShiptoSearch('');
                        setLoyaltySearch('');
                        // document.getElementById("shipto-search").value = "";
                      }}
                    />
                  )}
                  onChange={(value, a, reason) => {
                    if (reason === 'clear') {
                      setBilltoSearch('');
                      return;
                    }
                    if (a) {
                      setSelectedValue(a.customer_billto_account_number);
                      setOffset(1);
                    }
                  }}
                />
              </Grid>
              {/* <Grid item xs={12} lg={6} className={classes.btnGrid}>
                <Button
                  className={classes.submitBtn}
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  Submit
                </Button>
              </Grid> */}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Loader Loading={state.loading} top={'15%'}>
        {/* show user accounts */}    
        {accountType === "deactive user-account" && (<div>
          <h2 className={classes.deactiveError}>{deactiveAccount}</h2>
        </div>)}
        {accountType === "deactive user-account-shipto" && (<div>
          <h2 className={classes.deactiveError}>{deactiveAccount}</h2>
        </div>)}
      </Loader>
    </React.Fragment>
  );
}
